import { MODULE_LAUNCHER_LOGO_FILES } from "@itaas/core/branding/module-logo-catalog";

const PEP_PRODUCT_LOGO_BASE = "/assets/logos/products";

/** Logos produits PEP — alignés sur logo-registry.csv (pep_catalog_file). */
export function getProductLogoUrl(slug: string): string | undefined {
  const file = MODULE_LAUNCHER_LOGO_FILES[slug];
  if (!file) return undefined;
  return `${PEP_PRODUCT_LOGO_BASE}/${file}`;
}

export function hasProductLogo(slug: string): boolean {
  return slug in MODULE_LAUNCHER_LOGO_FILES;
}
